import { createStore, combineReducers, applyMiddleware, Middleware } from "redux"
import thunkMiddleware from "redux-thunk";
import { composeWithDevTools } from "redux-devtools-extension";
import { systemReducer } from "./system/reducers"
import { UserReducer } from "./MSIdentity/reducers";
import {productosReducer} from "./MSCommerce/Productos/reducers"
import {categoriesReducer} from "./MSCommerce/Categories/reducers"
import { ofertasReducer } from "./MSCommerce/Ofertas/reducers";
import { carritoReducer } from "./Carrito/reducers";
import { CarritoItem } from "./Carrito/types";

const rootReducer = combineReducers({
  system: systemReducer,
  userAction: UserReducer,
  productosAction:productosReducer,
  categoryAction:categoriesReducer,
  ofertasAction:ofertasReducer,
  carritoAction: carritoReducer,
});
export type AppState = ReturnType<typeof rootReducer>;

const CARRITO_STORAGE_KEY = 'glowskin_carrito';

function loadCarritoFromStorage(): CarritoItem[] {
  try {
    const raw = localStorage.getItem(CARRITO_STORAGE_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

export default function configureStore() {
  const middlewares: Middleware[] = [thunkMiddleware];
  const middleWareEnhancer = applyMiddleware(...middlewares);
  const preloadedState = {
    carritoAction: { items: loadCarritoFromStorage() },
  };
  const store = createStore(
    rootReducer,
    preloadedState as any,
    composeWithDevTools(middleWareEnhancer)
  );
  store.subscribe(() => {
    const items = store.getState().carritoAction.items;
    localStorage.setItem(CARRITO_STORAGE_KEY, JSON.stringify(items));
  });
  return store;
}

